import { useState } from "react";
import Icon1 from "@assets/icons/Icon";
import ChatPanel from "./ChatPanel";
import { useMessagerieStore } from "@store/messagerieStore";

interface FloatingChatWidgetProps {
  discussionId?: string;
  internalDiscussionId?: string;
  entityType?: "dossier" | "ordre";
  entityId?: string;
  entityName?: string;
}

export default function FloatingChatWidget({
  discussionId,
  internalDiscussionId,
  entityType,
  entityId,
  entityName,
}: FloatingChatWidgetProps) {
  const [open, setOpen] = useState(false);
  const discussions = useMessagerieStore((s) => s.discussions);

  const disc = discussions.find((d) => d.id === discussionId);
  const lastMsg = disc?.lastMessage;

  return (
    <div className="2xl:hidden">
      {open ? (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col border rounded-[15px] overflow-hidden shadow-xl" style={{ width: 400, height: 600, maxHeight: "calc(100vh - 48px)", background: "#FFFFFF", borderColor: "#D9D9D9" }}>
          <div className="flex flex-row items-center justify-between px-4 py-2 border-b border-neutral-200">
            <span className="text-h2 font-medium">Conversation</span>
            <button onClick={() => setOpen(false)} className="hover:bg-neutral-100 rounded-full p-1">
              <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
                <path d="M1 1L11 11M11 1L1 11" stroke="#A1A1A1" strokeWidth={1.5} strokeLinecap="round" />
              </svg>
            </button>
          </div>
          <div className="flex-1 overflow-hidden">
            <ChatPanel
              discussionId={discussionId}
              internalDiscussionId={internalDiscussionId}
              entityType={entityType}
              entityId={entityId}
              entityName={entityName}
              members={[]}
              onlineCount={0}
              compact
            />
          </div>
        </div>
      ) : (
        <button
          onClick={() => setOpen(true)}
          className="fixed bottom-6 right-6 z-50 flex flex-row items-center gap-3 rounded-full px-5 py-3 shadow-xl hover:scale-105 transition-transform"
          style={{ background: "#000000", maxWidth: 300 }}
        >
          <Icon1 name="message" size={20} color="#FFFFFF" />
          <span className="text-h3 font-medium text-white truncate">
            {lastMsg || "Conversation"}
          </span>
        </button>
      )}
    </div>
  );
}
